import React from "react";
import BaseList from "../../components/BaseList";
import Toggle from "../../components/DataGrid/toggle.js";

const getColumns = ({ podeEditar, navigate, baseRoute, onToggleStatus }) => {
  return [
    { field: "nome", header: "Nome", sortable: true },
    { 
      field: "descricao", 
      header: "Descrição",
      render: (row) => row.descricao || <span className="text-gray-400">-</span>
    },
    { 
      key: "quantidadePermissoes",
      header: "Permissões",
      width: "120px",
      className: "text-center",
      headerClassName: "text-center",
      render: (row) => (
        <span className={`px-2 py-1 rounded text-xs font-medium ${
          row.quantidadePermissoes > 0 
            ? 'bg-blue-100 text-blue-700' 
            : 'bg-gray-100 text-gray-500'
        }`}>
          {row.quantidadePermissoes || 0}
        </span>
      )
    },
    { 
      key: "quantidadeUsuarios",
      header: "Usuários",
      width: "100px",
      className: "text-center",
      headerClassName: "text-center",
      render: (row) => (
        <span className={`px-2 py-1 rounded text-xs font-medium ${
          row.quantidadeUsuarios > 0 
            ? 'bg-emerald-100 text-emerald-700' 
            : 'bg-gray-100 text-gray-500'
        }`}>
          {row.quantidadeUsuarios || 0}
        </span>
      )
    },
    {
      key: "ativo",
      header: "Ativo",
      className: "text-center",
      headerClassName: "text-center",
      width: "100px",
      render: (row) => (
        <div onClick={(e) => e.stopPropagation()}>
          <Toggle
            value={row.ativo}
            onChange={() => onToggleStatus(row.id, row.ativo)}
            disabled={!podeEditar}
          />
        </div>
      ),
    },
    {
      key: "acoes",
      header: "Ações",
      width: "100px",
      className: "text-center",
      headerClassName: "text-center",
      render: (row) => (
        podeEditar ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
              navigate(`${baseRoute}/${row.id}`);
            }}
            className="p-2 text-gray-600 hover:text-slate-900 hover:bg-gray-100 rounded"
            title="Editar"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
            </svg>
          </button>
        ) : null
      ),
    },
  ];
};

export default function GrupoList() {
  return (
    <BaseList
      titulo="Grupos"
      endpoint="grupos"
      baseRoute="/grupos"
      getColumns={getColumns}
      permissoes={{
        criar: "grupos.criar",
        editar: "grupos.editar",
        remover: "grupos.remover",
      }}
      emptyMessage="Nenhum grupo encontrado"
      novoButtonText="Novo Grupo"
      emptyButtonText="Cadastrar primeiro grupo"
    />
  );
}